export default __webpack_public_path__ + "static/media/The Fleeted Wing.f3193da0.jpg";